import DurationInput from '@/components/common/DurationInput';
import FormGroupWithTooltip from '@/components/common/FormGroup/FormGroupWithTooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackEditViewTemplateProps } from '../TrackEditViewTemplate';

type Props = Pick<
  TrackEditViewTemplateProps,
  | 'trackData'
  | 'handleDuration'
  | 'fieldHasErrors'
  | 'fieldValidationState'
  | 'findErrorMessage'
  | 'isMultipleTrack'
> & {
  readonly?: boolean;
  disabled?: boolean;
  trackKey: string;
};

export default function TrackDurationFormGroup({
  isMultipleTrack,
  trackData,
  readonly,
  disabled,
  handleDuration,
  fieldHasErrors,
  fieldValidationState,
  findErrorMessage,
  trackKey,
}: Props) {
  const { t } = useTranslation();
  const hasErrors = !isMultipleTrack ? fieldHasErrors('Duration') : false;

  return (
    <FormGroupWithTooltip
      tooltipKey="tooltip.track.length"
      hasErrors={hasErrors}
    >
      {!isMultipleTrack ? (
        <DurationInput
          key={`duration-${trackKey}`}
          labelClassName="col-sm-3 form-label"
          inputClassname="form-control"
          className="col-sm-6"
          labelTitle={t('track.duration')}
          placeholder={t('track.durationPlaceholder')}
          id="duration"
          durationSeconds={trackData?.duration}
          invalidFormatErrorMessage={t(
            'validationAlert.trackEditMode.Duration.InvalidValue.ErrorMessage'
          )}
          onDurationSecondsChange={handleDuration}
          isReadOnly={readonly}
          isDisabled={disabled}
          hasErrors={hasErrors}
          validationState={
            !isMultipleTrack ? fieldValidationState?.('Duration') : undefined
          }
          errorMessage={!isMultipleTrack ? findErrorMessage('Duration') : ''}
        />
      ) : null}
    </FormGroupWithTooltip>
  );
}
